import { Component, Input } from "@angular/core";

@Component({
    selector: 'corp-modal',
    templateUrl: './corp-modal.component.html',
    standalone: true,
    imports: []
  })
  export class CorpModalComponent {
    @Input() title : string = ''; 
    @Input() active = false;

    toggleClass(): boolean {
        this.active = !this.active;
        return this.active;
    }
  }